import Vue from 'vue'
import { IResponseAgGrid } from '@/shared/models/ag-grid.model'
import { ContentNotificationTypesGrid } from '@/modules/configurationModule/detail/notifications/components/notification-types-grid/notification-types-grid.models'
import { EntityIdentifiersRequest, EntityIdentifierWithErrorResponse } from '@/shared/models/http/http.model'

class LocalNotificationConfigurationServices extends Vue {
    async paginator(filterModel: any, params: any, laboratoryId: number): Promise<IResponseAgGrid<ContentNotificationTypesGrid>> {
        const response = await this.axios.put(`/configuration/laboratories/${laboratoryId}/notificationConfiguration`, filterModel, { params })
        return response.data
    }
    async getGlobalNotificationById(notificationConfigurationId: number, laboratoryId: number): Promise<ContentNotificationTypesGrid> {
        const response = await this.axios.get(`/configuration/laboratories/${laboratoryId}/notificationConfiguration/${notificationConfigurationId}`)
        return response.data
    }
    async patchGlobalNotificationBatch(request: ContentNotificationTypesGrid[], laboratoryId: number): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await this.axios.patch(`/configuration/laboratories/${laboratoryId}/notificationConfiguration/batch`, request)
        return response.data
    }
    async createGlobalNotification(request: ContentNotificationTypesGrid, laboratoryId: number): Promise<ContentNotificationTypesGrid> {
        const response = await this.axios.post(`/configuration/laboratories/${laboratoryId}/notificationConfiguration`, request)
        return response.data
    }
    async deleteGlobalNotificationBatch(request: EntityIdentifiersRequest, laboratoryId: number): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await this.axios.delete(`/configuration/laboratories/${laboratoryId}/notificationConfiguration/batch`, { data: request })
        return response.data
    }
}

export const localNotificationConfigurationServices = new LocalNotificationConfigurationServices()
